import React, { Component } from "react";
import { Row, Col, Card, Button, Container } from "react-bootstrap";
import DataTableWithOutSearch from "../datatables/DataTableWithOutSearch";
import SelectDropDown from '../../../neetjee_guru/components/selectdropdown/SelectDropDown'
import { components } from 'react-select'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import TableSearchwithStudentResult from "../questioners/manage_questin_papers/TableSearchwithStudentResult";
import BreadcrumbsSection from "../breadcrumbs/BreadcrumbsSection";
import StudentModal from './addStudentsModal'
import EditDetailsModal from './editDetailsModal';
import { Link } from "react-router-dom";
import CardLessDataTable from "../datatables/CardLessDataTableWithSearch";
import './_educationManagementStudents.scss';

const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
        b_e_c_s_data {
            section_id
            class_id
            branch_id
            exam_id
        }
      globalPackages {
        id
        package_name
        exams_covered
      }
      educationalClasses {
        id
        class
      }
      globalCategories {
        id
        category_name
        package_id
      }
      classes {
        id
        class
      }
      exams {
        id
        exam
      }
      globalBranches {
        id
        branch_name
      }
      globalSections {
        id
        section_name
        branch_id
        category_id
        package_id
      }
    }
  }
`;

const GET_STUDENT_DETAILS = gql`
query($institute_id:Int){
    getNewEducationalStudents(institute_id: $institute_id) {
        roll_no
        student_name
        class_id
        class_name
        exam_id
        exam_name
        branch_id
        branch_name
        section_id
        section_name
        parent_name
        parent_mobile
        parent_password
        student_id
        student_mobile
        is_academic_exist
        is_non_academic_exist
      }
}
`
const EDIT_PARENT = gql`
  mutation($params: EditParent) {
    editParent(params: $params)
  }
`;

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

class EducationManagementStudentsSection extends Component {
    constructor(props) {
        super(props)
        this.state = {


            branchSearch: "0",
            branchSearchval: "",
            examSearch: "0",
            examSearchval: "",
            getExams: [],
            classSearch: "0",
            classSearchval: "",
            getClasses: [],
            sectionSearch: "0",
            sectionSearchval: "",
            getSections: [],
            modalShow: false,

            mobile: "",
            loadingSpinner: 0,
            tableHeaderData: { Title: "Students", },
            editModal: false,
            rowData: [],
            parentName: "",
            parentNameError: "",
            parentMobile: "",
            parentMobileError: "",
            parentPassword: "",
            parentPasswordError: "",
            confirmParentPassword: "",
            confirmPasswordError: "",
            cButton: true,
            student_id: 0,
            submitError: "",
            loadingSpinner: 0,
            currentStep: 1,
            isSubmitting: false,
        }
    };

    selecthandleInputChange = (ename, evalue) => {
        const name = ename;
        const value = evalue;
        console.log("aaaaaa", ename, evalue);
        if (name == "branchSearch") {
            if (value != "0") {
                let branchSearchData = this.props.globals.globals.globalBranches.find((a) => a.id == value);
                this.setState({
                    branchSearchval: {
                        value: branchSearchData.id,
                        label: branchSearchData.branch_name
                    },
                    branch: branchSearchData.branch_name,

                    examSearch: "0",
                    examSearchval: "",
                    getExams: [],

                    classSearch: "0",
                    classSearchval: "",
                    getClasses: [],

                    sectionSearch: "0",
                    sectionSearchval: "",
                    getSections: [],
                })
                this.dropDownGetValues('examSearch', value)
            } else {
                this.setState({
                    branchSearchval: {
                        value: "0",
                        label: "Select Branch"
                    },
                    branchSearch: "0",
                    branchSearchval: "",

                    examSearch: "0",
                    examSearchval: "",
                    getExams: [],

                    classSearch: "0",
                    classSearchval: "",
                    getClasses: [],

                    sectionSearch: "0",
                    sectionSearchval: "",
                    getSections: [],
                })
            }
        } else if (name == "examSearch") {
            if (value != "0") {
                let examSearchData = this.props.globals.globals.exams.find((a) => a.id == value);
                this.setState({
                    examSearchval: {
                        value: examSearchData.id,
                        label: examSearchData.exam
                    },
                    exam: examSearchData.exam,
                    classSearch: "0",
                    classSearchval: "",
                    getClasses: [],

                    sectionSearch: "0",
                    sectionSearchval: "",
                    getSections: [],
                })
                this.dropDownGetValues('classSearch', value)
            } else {
                this.setState({
                    sectionSearchval: {
                        value: "0",
                        label: "Select Exam"
                    },
                    classSearch: "0",
                    classSearchval: "",
                    getClasses: [],

                    sectionSearch: "0",
                    sectionSearchval: "",
                    getSections: [],
                })
            }
        } else if (name == "classSearch") {
            if (value != "0") {
                let classSearchData = this.props.globals.globals.educationalClasses.find((a) => a.id == value);
                this.setState({
                    classSearchval: {
                        value: classSearchData.id,
                        label: classSearchData.class
                    },
                    class: classSearchData.class,
                    sectionSearch: "0",
                    sectionSearchval: "",
                    getSections: [],
                })
                this.dropDownGetValues('sectionSearch', value);
            } else {
                this.setState({
                    classSearchval: {
                        value: "0",
                        label: "Select"
                    },
                    sectionSearch: "0",
                    sectionSearchval: "",
                    getSections: [],
                })
            }
        } else if (name == "sectionSearch") {
            if (value != "0") {
                let sectionSearchData = this.props.globals.globals.globalSections.find((a) => a.id == value);
                this.setState({
                    sectionSearchval: {
                        value: sectionSearchData.id,
                        label: sectionSearchData.section_name
                    },
                    section: sectionSearchData.section_name,
                })
            } else {
                this.setState({
                    sectionSearchval: {
                        value: "0",
                        label: "Select"
                    },
                })
            }
        }
        this.setState({ [name]: value });
    };

    dropDownGetValues(fieldname, value) {
        let getArray = [];

        if (fieldname == "branchSearch") {
            const newObj1 = {
                value: "0",
                label: "Select Branch"
            }
            getArray.push(newObj1);
        } else if (fieldname == "examSearch") {
            const newObj1 = {
                value: "0",
                label: "Select Exam"
            }
            getArray.push(newObj1);
        } else if (fieldname == "classSearch") {
            const newObj1 = {
                value: "0",
                label: "Select Class"
            }
            getArray.push(newObj1);
        } else if (fieldname == "sectionSearch") {
            const newObj1 = {
                value: "0",
                label: "Select Section"
            }
            getArray.push(newObj1);
        }

        if (fieldname == "branchSearch") {
            let uniqueBranches = [...new Set(this.props.globals.globals.b_e_c_s_data.map((item) => item.branch_id))];
            uniqueBranches.map((val) => {
                let individualBranchData = this.props.globals.globals.globalBranches.find((item1) => item1.id == val);
                const newObj = {
                    value: individualBranchData.id,
                    label: individualBranchData.branch_name
                }
                getArray.push(newObj);
            })
        } else if (fieldname == "examSearch") {
            let uniqueExams = [...new Set(this.props.globals.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();
            uniqueExams.map((val) => {
                let individualExamData = this.props.globals.globals.exams.find((item1) => item1.id == val);
                const newObj = {
                    value: individualExamData.id,
                    label: individualExamData.exam
                }
                getArray.push(newObj);
            })
            this.setState({ getExams: getArray })

        } else if (fieldname == "classSearch") {

            let uniqueClasses = [...new Set(this.props.globals.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == value).map((item1) => item1.class_id))].sort();

            uniqueClasses.map((val) => {
                let individualClassData = this.props.globals.globals.educationalClasses.find((item1) => item1.id == val);
                const newObj = {
                    value: individualClassData.id,
                    label: individualClassData.class
                }
                getArray.push(newObj);
            })

            this.setState({ getClasses: getArray })

        } else if (fieldname == "sectionSearch") {
            let uniqueSections = [...new Set(this.props.globals.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == this.state.examSearch && item.class_id == value).map((item1) => item1.section_id))].sort();
            uniqueSections.map((val) => {
                let individualSectionData = this.props.globals.globals.globalSections.find((item1) => item1.id == val);
                const newObj = {
                    value: individualSectionData.id,
                    label: individualSectionData.section_name
                }
                getArray.push(newObj);
            })
            this.setState({ getSections: getArray })
        }
        return getArray;
    };

    tableData(students) {

        console.log("studentsstudentsstudents", students)
        const student_data = Array();

        for (let i = 0; i < students.length; i++) {
            const branchs = this.props.globals.globals.globalBranches.find(
                (e) => e.id == students[i].branch_id
            );
            let b_id = "";
            let branch1 = "";
            if (branchs != undefined) {
                branch1 = branchs.branch_name;
                b_id = branchs.id;
            }
            const exams = this.props.globals.globals.exams.find(
                (e) => e.id == students[i].exam_id
            );
            let exam_id = "";
            let examName = "";
            if (exams != undefined) {
                examName = exams.exam;
                exam_id = exams.id;
            }

            const classes = this.props.globals.globals.classes.find(
                (e) => e.id == students[i].class_id
            );
            let c_id = "";
            let class1 = "";
            if (classes != undefined) {
                class1 = classes.class;
                c_id = classes.id;
            }

            const sections = this.props.globals.globals.globalSections.find(
                (e) => e.id == students[i].section_id
            );
            let s_id = "";
            let section1 = "";
            if (sections != undefined) {
                section1 = sections.section_name;
                s_id = sections.id;
            }

            student_data.push({
                id: students[i].id,
                student_name: students[i].student_name,
                contact_no: students[i].student_mobile,
                exam_name: examName,
                exam_id: exam_id,
                branch_id: branch1,
                class_id: class1,
                section_id: section1,
                branch: b_id,
                class: c_id,
                section: s_id,
                class_name: students[i].class_name,
                branch_name: students[i].branch_name,
                exam_name: students[i].exam_name,
                section_name: students[i].section_name,
                parent_name: students[i].parent_name != null ? students[i].parent_name : "-",
                parent_mobile: students[i].parent_mobile != null ? students[i].parent_mobile : "-",
                parent_password: students[i].parent_password,
                student_id: students[i].student_id,
                roll_no: students[i].roll_no,
                is_academic_exist: students[i].is_academic_exist,
                is_non_academic_exist: students[i].is_non_academic_exist
            });
        }

        return student_data;
    };

    articlecolumns = [
        {
            dataField: "student_name",
            text: "Student Name",
            sort: true,
            formatter: this.studentNameFunc.bind(this),
        },

        {
            dataField: "roll_no",
            text: "Roll No",
            sort: true,
        },

        {
            dataField: "branch_name",
            text: "Branch",
            sort: true,
        },

        {
            dataField: "exam_name",
            text: "Exam",
            sort: true,
        },

        {
            dataField: "class_name",
            text: "Class",
            sort: true,
        },

        {
            dataField: "section_name",
            text: "Section",
            sort: true,
        },

        {
            dataField: "parent_name",
            text: "Parent Name",
            sort: true,
        },

        {
            dataField: "parent_mobile",
            text: "Parent Mobile",
            sort: true,
        },

        {
            dataField: "",
            text: "Edit Parent Details",
            sort: true,
            formatter: this.performanceFunc.bind(this),
        },
    ];

    studentNameFunc(cell, row, rowIndex, formatExtraData) {

        console.log("lllll", row)

        let row1 = [];

        if (row != null) {
            row1.push({ class_id: row.class, branch_id: row.branch, section_id: row.section, profile_pic: "", student_name: row.student_name, contact_no: row.roll_no, exam_id: row.exam_id, contact_no: row.contact_no, is_academic_exist: row.is_academic_exist, is_non_academic_exist: row.is_non_academic_exist })
        }

        return (<>
            <div className="text-link d-flex flex-column">
                <Link
                    style={{ textDecoration: "underline" }}
                    to={{
                        pathname: "/home/student-profile",
                        back: "/settings/instituteStudents",
                        state: {
                            //globals: this.props.globals,
                            row: row1[0],
                            rowIndex: rowIndex,
                            type: "non-academic"
                        }
                    }}
                >
                    {/* {row["student_name"]} */}
                    <span style={{ textDecoration: "underline", color: "#000" }}>
                        {row["student_name"]}
                    </span>
                </Link>
            </div>
        </>)
    };

    performanceFunc(cell, row, rowIndex, formatExtraData) {
        console.log("rowwwwwwwwwww", row)
        return (<>
            <div className="actions-buttons d-flex justify-content-center align-items-top" onClick={() => this.EditModal(row)}>
                <Button variant="link" name="edit" className="text-theme">
                    <i className="far fa-edit" />
                </Button>
            </div>
        </>)
    };

    EditModal = (data) => {
        this.setState({
            editModal: true,
            rowData: data,
            parentName: data.parent_name != "-" ? data.parent_name : "",
            parentMobile: data.parent_mobile != "-" ? data.parent_mobile : "",
            parentPassword: data.parent_password != null ? data.parent_password : "",
            student_id: data.student_id
        })
    };

    parentHandleInputChange = async (e) => {
        const name = e.target.name;
        const value = e.target.value;

        if (name == "parent_name") {
            this.setState({ parentName: value, parentNameError: "" })
        }
        if (name == "parent_mobile") {
            this.setState({ parentMobile: value })
            if (value.length <= 9 || value.length > 10) {
                this.setState({ parentMobileError: "Mobile number must be 10 digits" })
            } else {
                this.setState({ parentMobileError: "" })
            }
        }

        if (name == "parent_password") {
            this.setState({ parentPassword: value, parentPasswordError: "" })
        }
    };

    handleFormSubmit = async (e) => {

        if (this.state.parentName == "") {
            this.setState({ parentNameError: "Please enter name" })
            return ""
        }
        if (this.state.parentMobile == "" || this.state.parentMobile.length > 10 || this.state.parentMobile.length < 10) {
            this.setState({ parentMobileError: "Please Check Mobile number" })
            return ""
        }
        if (this.state.parentPassword == "") {
            this.setState({ parentPasswordError: "Please enter Password" })
            return ""
        }

        this.setState({ isSubmitting: true })

        let params = {
            student_id: parseInt(this.state.student_id),
            parent_mobile: this.state.parentMobile.toString(),
            parent_name: this.state.parentName,
            parent_password: this.state.parentPassword
        }
        this.editParent(params).catch((error) => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map((x) => x.message),
            });
            console.error(
                "ERR =>",
                error.graphQLErrors.map((x) => x.message)
            );
        });
    }

    editParent = async params => {
        await this.props.editParent({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.editParent) {
                    this.setState({
                        loadingSpinner: 1,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        })
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "", loadingSpinner: 0, editModal: false });
        window.location.reload(false);
    };

    render() {

        console.log("student_id", this.state)

        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;

        const getNewEducationalStudents = this.props.getNewEducationalStudents;
        const loading2 = getNewEducationalStudents.loading;
        const error2 = getNewEducationalStudents.error

        if (loading1 || loading2) return null;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }

        let StudentsFilterData = [];
        if (
            (
                // this.state.studentnameSearch != "0" ||
                // this.state.packageSearch != "0" ||
                this.state.branchSearch != "0" ||
                this.state.classSearch != "0" ||
                this.state.sectionSearch != "0" ||
                // this.state.categorySearch != "0" ||
                this.state.examSearch != "0"
            )

        ) {
            StudentsFilterData = getNewEducationalStudents.getNewEducationalStudents;

            if (this.state.classSearch != "0") {
                StudentsFilterData = StudentsFilterData.filter((a) => a.class_id == this.state.classSearch);
            }
            if (this.state.examSearch != "0") {
                StudentsFilterData = StudentsFilterData.filter((a) => a.exam_id == this.state.examSearch);
            }
            if (this.state.sectionSearch != "0") {
                StudentsFilterData = StudentsFilterData.filter((a) => a.section_id == this.state.sectionSearch);
            }
            if (this.state.branchSearch != "0") {
                StudentsFilterData = StudentsFilterData.filter((a) => a.branch_id == this.state.branchSearch);
            }
        }
        else {
            StudentsFilterData = getNewEducationalStudents.getNewEducationalStudents;
        }

        return (
            <Container>
                <Row className="mt-2">
                    <Col xl={12} lg={12} md={12} sm={12}>
                        <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
                            <h2 className="title h5 mb-0">NON-ACADEMIC STUDENTS</h2>
                            <div className='d-flex justify-content-end mr-1'>
                                <div>
                                    <button style={{ backgroundColor: "rgb(27,35,61)", color: "#fff", height: "35px", width: "145px" }} onClick={() => this.setState({ modalShow: true })}>ADD STUDENT</button>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col sm={12}>
                        <Card className="border-0 shadow-sm mb-4">
                            <Card.Header>
                                <Row>
                                    <Col lg={3} md={12} sm={12}>
                                        {/* BRANCH */}
                                        <SelectDropDown
                                            stateData={this.state.branchSearchval}
                                            handleChange={this.selecthandleInputChange}
                                            name="branchSearch"
                                            options={this.dropDownGetValues("branchSearch")}
                                            placeholderName={'Select Branch'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                        />
                                    </Col>

                                    <Col lg={3} md={12} sm={12}>
                                        {/* EXAMS */}
                                        <SelectDropDown
                                            stateData={this.state.examSearchval}
                                            handleChange={this.selecthandleInputChange}
                                            name="examSearch"
                                            options={this.state.getExams}
                                            placeholderName={'Select Exam'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                        />
                                    </Col>

                                    <Col lg={3} md={12} sm={12}>
                                        {/* CLASS */}
                                        <SelectDropDown
                                            stateData={this.state.classSearchval}
                                            handleChange={this.selecthandleInputChange}
                                            name="classSearch"
                                            options={this.state.getClasses}
                                            placeholderName={'Select Class'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                        />
                                    </Col>

                                    <Col lg={3} md={12} sm={12}>
                                        {/* SECTION */}
                                        <SelectDropDown
                                            stateData={this.state.sectionSearchval}
                                            handleChange={this.selecthandleInputChange}
                                            name="sectionSearch"
                                            options={this.state.getSections}
                                            placeholderName={'Select Section'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                        />
                                    </Col>
                                </Row>
                            </Card.Header>

                            <Card.Body>
                                <CardLessDataTable
                                    parentData={this.tableData(StudentsFilterData)}
                                    particlecolumns={this.articlecolumns}
                                    tableHeading={this.state.tableHeaderData}
                                    search={true}
                                    name="hostel_attendance"
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <StudentModal
                    globals={globals.globals}
                    show={this.state.modalShow}
                    onHide={() => this.setState({ modalShow: false })}
                />
                <EditDetailsModal
                    show={this.state.editModal}
                    onHide={() => this.setState({ editModal: false, parentName: "", parentNameError: "", parentMobile: "", parentMobileError: "", parentPassword: "", parentPasswordError: "", confirmParentPassword: "", confirmPasswordError: "", submitError: "", student_id: 0, isSubmitting: false })}
                    stateData={this.state}
                    parentHandleInputChange={this.parentHandleInputChange}
                    handleFormSubmit={this.handleFormSubmit}
                />
            </Container>
        )
    };
};
export default withRouter(compose(
    graphql(FETCH_GLOBALS, {
        options: (props) => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
            },
        }),
        name: "globals",
    }),
    graphql(GET_STUDENT_DETAILS, {
        options: (props) => ({
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
            },
        }),
        name: "getNewEducationalStudents",
    }),
    graphql(EDIT_PARENT, {
        name: "editParent",
    })
)(EducationManagementStudentsSection));